// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.theme-2-deposit-type-section-active {\n  background-color: #fbe88b !important;\n  color: #010101 !important;\n  margin-left: 5px;\n}\n.theme-2-deposit-type-section {\n  background-color: rgba(255, 255, 255, 10%) !important;\n  color: #fff !important;\n  margin-left: 5px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
